import React from 'react';
import styles from './PendingModal.module.css';

const PendingModal = ({ invoice, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    const date = new Date(timeString);
    return date.toLocaleTimeString('en-GB', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const formatCurrency = (amount, currency = 'INR') => {
    const symbol = currency === 'USD' ? '$' : '₹';
    return symbol + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Invoice Details - #{invoice.invoiceNum}</h2>
          <button onClick={onClose} className={styles.closeButton}>✕</button>
        </div>
        
        <div className={styles.modalBody}>
          <div className={styles.alertBox}>
            <span className={styles.alertIcon}>⚠️</span>
            <strong>Pending Dispatch:</strong> This invoice has not been dispatched yet.
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Basic Information</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>Invoice #:</span>
                <span className={styles.value}>{invoice.invoiceNum}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Invoice Date:</span>
                <span className={styles.value}>{formatDate(invoice.invoiceDate)}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Status:</span>
                <span className={`${styles.statusBadge} ${styles[`status${invoice.status?.replace(/\s+/g, '')}`]}`}>
                  {invoice.status}
                </span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Invoice Time:</span>
                <span className={styles.value}>{formatTime(invoice.invoiceTime)}</span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Sales Order Information</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>SO #:</span>
                <span className={styles.value}>{invoice.soNum || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>SO Date:</span>
                <span className={styles.value}>{formatDate(invoice.soDate)}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Order Time:</span>
                <span className={styles.value}>{formatTime(invoice.orderTime)}</span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Customer Information</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>Customer Code:</span>
                <span className={styles.value}>{invoice.customerCode}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Customer Name:</span>
                <span className={styles.value}>{invoice.customerName}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Contact Person:</span>
                <span className={styles.value}>{invoice.contactPersonName || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Contact Code:</span>
                <span className={styles.value}>{invoice.contactPersonCode || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Due Date:</span>
                <span className={styles.value}>{formatDate(invoice.dueDate)}</span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Financial Details</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>Total Amount:</span>
                <span className={styles.valueHighlight}>{formatCurrency(invoice.totalAmount, invoice.currency)}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Currency:</span>
                <span className={styles.value}>{invoice.currency}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Total Lines:</span>
                <span className={styles.value}>{invoice.totalLines}</span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Dispatch Information</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>Dispatch Date:</span>
                <span className={styles.pendingBadge}>Pending Dispatch</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Tracking #:</span>
                <span className={styles.value}>{invoice.trackingNum || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Transport:</span>
                <span className={styles.value}>{invoice.transport || 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Sales Information</h3>
            <div className={styles.grid}>
              <div className={styles.field}>
                <span className={styles.label}>Sales Person Code:</span>
                <span className={styles.value}>{invoice.salesPersonCode || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.label}>Sales Person:</span>
                <span className={styles.value}>{invoice.salesPerson || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.closeBtn}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PendingModal;